// -------------------------------------------------------------------------
// スプラッシュ
// -------------------------------------------------------------------------
import { startAnimation, gsap } from '../foundation/animation';
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";

// 定数
const HOME_SPLASH_TIMEOUT = 800; // ホームページのスプラッシュ表示時間 (ms)
const PAGE_SPLASH_TIMEOUT = 50; // 他のページのスプラッシュ表示時間 (ms)
const PAGE_TRANSITION_DURATION = 500; // ページ遷移アニメーション時間 (ms)

// NOTE: スプラッシュのクラスの追加/削除を管理する関数
function toggleSplashClasses(action) {
    const htmlElement = document.querySelector('html');

    if (action === 'show') {
        htmlElement.classList.add('is-splash-show', 'is-noscroll');
    } else if (action === 'hide') {
        htmlElement.classList.remove('is-splash-show', 'is-noscroll', 'is-splash-hide');
    } else if (action === 'hide-transition') {
        htmlElement.classList.add('is-splash-hide');
    }
}

// NOTE: スプラッシュを非表示にする関数
function hideSplash() {
    const splashElement = document.querySelector('.m-splash');

    toggleSplashClasses('hide-transition');
    startAnimation(); // 非表示が完了したタイミングでアニメーション開始

    // アニメーション終了を検知して、DOMを削除
    splashElement.addEventListener('animationend', () => {
        toggleSplashClasses('hide');
        // document.querySelector('html').classList.add('is-animation-ready');

        // スプラッシュアニメーション終了のカスタムイベントを発火
        document.dispatchEvent(new Event('splashAnimationEnd'));

        // スプラッシュ画面のDOMを削除
        splashElement.remove();
    }, { once: true });
}

// NOTE: スプラッシュを表示する関数
function showSplash() {
    toggleSplashClasses('show');
}

// NOTE: スプラッシュの種類に応じた表示時間を設定する関数
function setSplashTimeout() {
    const splashElement = document.querySelector('.m-splash');

    if (splashElement) {
        // スプラッシュの種類によって表示時間を変更
        if (splashElement.classList.contains('m-splash--home')) {
            setTimeout(hideSplash, HOME_SPLASH_TIMEOUT); // ホームページは1秒
        } else if (splashElement.classList.contains('m-splash--page')) {
            setTimeout(hideSplash, PAGE_SPLASH_TIMEOUT); // 他のページは0.05秒
        }
    }
}

// NOTE: ページ遷移時のクラスを管理する関数
function startPageTransition(url) {
    const htmlElement = document.querySelector('html');

    // ページ遷移用のクラスを追加
    htmlElement.classList.add('is-page-transition');

    // 遷移後のURLにリダイレクト
    setTimeout(() => {
        window.location.href = url;
    }, PAGE_TRANSITION_DURATION); // アニメーション時間を0.5秒に設定
}

// NOTE: ページ遷移終了時のクラスを管理
function endPageTransition() {
    const htmlElement = document.querySelector('html');
    htmlElement.classList.remove('is-page-transition');
}

// 初期化処理
document.addEventListener('DOMContentLoaded', () => {
    // スプラッシュ画面を表示
    showSplash();

    // スプラッシュ画面の種類に応じてタイムアウトを設定
    window.addEventListener('load', setSplashTimeout);

    // 内部リンクのクリックを監視してページ遷移クラスを追加
    document.querySelectorAll('a[href]').forEach(link => {
        link.addEventListener('click', (e) => {
            const url = link.getAttribute('href');

            // 外部リンク、アンカーリンク、新しいタブで開くリンクを除外
            if (!url || url.startsWith('#') || url.startsWith('http') || link.target === '_blank') return;

            e.preventDefault();
            startPageTransition(url);
        });
    });

    // ブラウザバック対応
    window.addEventListener('popstate', () => {
        // ページ遷移のクラスを削除
        endPageTransition();

        // スプラッシュが再表示されないようにする
        const splashElement = document.querySelector('.m-splash');
        if (splashElement) {
            splashElement.style.display = 'none';
        }
    });
});


document.addEventListener("DOMContentLoaded", function() {
    const progressBar = document.querySelector('.m-splash__line');
    if (!progressBar) return; // progressBarが存在しない場合は処理を中断

    const resources = document.images;
    const totalResources = resources.length;
    let loadedResources = 0;

    function updateProgress() {
        loadedResources++;
        let progress = (loadedResources / totalResources) * 100;

        if (progressBar) { // progressBarがnullでないか確認
            progressBar.style.clipPath = `inset(0 ${100 - progress}% 0 0)`;
        }
    }

    // すべての画像に対してロードリスナーを設定
    for (let i = 0; i < totalResources; i++) {
        if (resources[i].complete) {
            updateProgress();
        } else {
            resources[i].addEventListener('load', updateProgress);
            resources[i].addEventListener('error', updateProgress);
        }
    }

    window.addEventListener('load', function() {
        if (progressBar) { // progressBarがnullでないか確認
            progressBar.style.clipPath = 'inset(0 0% 0 0)';
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const target = document.querySelector('.m-splash__text--main');
    const splashElement = document.querySelector('.m-splash');
    if (!target || !splashElement) return;

    gsap.registerPlugin(ScrambleTextPlugin);

    const words = [
        "Force", "Firm", "Fast Forward", "Full Stack",
        "product development",
        "professional", "talent matching", "system integration",
        "technology consulting"
    ];

    let wordSwitchingAnimation;

    // スライドアップアニメーション
    const initialText = "Force";
    target.textContent = ''; // テキストをクリア
    const chars = initialText.split('');

    chars.forEach(char => {
        const span = document.createElement('span');
        span.textContent = char;
        span.style.display = 'inline-block'; // アニメーションのためにインラインブロックに
        target.appendChild(span);
    });

    gsap.from(target.children, {
        y: '100%',
        opacity: 0,
        filter: 'blur(5px)',
        stagger: 0.02,
        ease: 'power3.out',
        onComplete: () => {
            // アニメーション完了後、単語切り替えを開始
            target.innerHTML = initialText; // 元のテキストに戻す
            let wordIndex = 0;
            const switchInterval = 80;

            wordSwitchingAnimation = setInterval(() => {
                wordIndex = (wordIndex + 1) % words.length;
                target.textContent = words[wordIndex];
            }, switchInterval);
        }
    });

    // スプラッシュが非表示になるタイミングでアニメーションを停止
    const htmlEl = document.querySelector('html');
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.attributeName === 'class' && htmlEl.classList.contains('is-splash-hide')) {
                target.textContent = "Force";
                if (wordSwitchingAnimation) {
                    clearInterval(wordSwitchingAnimation);
                }
                observer.disconnect();
            }
        });
    });

    observer.observe(htmlEl, { attributes: true });
});
